// Anonymous local-first identity + settings for ExhaleType.
// We keep everything in localStorage. No accounts, no fingerprinting.
const ANON_KEY = 'exhale.anonId';
const SETTINGS_KEY = 'exhale.settings';

const DEFAULT_SETTINGS = {
  breathing: true,
  ambientSound: false,
  reflections: true,
};

const isBrowser = typeof window !== 'undefined' && !!window.localStorage;

function uuid() {
  if (isBrowser && window.crypto?.randomUUID) return window.crypto.randomUUID();
  // RFC-4122 v4-ish fallback
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getAnonId() {
  if (!isBrowser) return 'anon-server';
  let id = window.localStorage.getItem(ANON_KEY);
  if (!id) {
    id = uuid();
    window.localStorage.setItem(ANON_KEY, id);
  }
  return id;
}

export function getSettings() {
  if (!isBrowser) return { ...DEFAULT_SETTINGS };
  try {
    const raw = window.localStorage.getItem(SETTINGS_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(next) {
  if (!isBrowser) return;
  window.localStorage.setItem(SETTINGS_KEY, JSON.stringify(next));
}
